import React from 'react';
import advieskeuzeLogo from "~/assets/images/logo-icon.svg";

type LoaderProps = {
  message?: string;
  showLogo?: boolean;
};

const Loader: React.FC<LoaderProps> = ({ message, showLogo }) => {
  return (
    <div className="loading-spinner">
      <div className="loading-spinner__wrapper">
        {showLogo && (
          <img
            className="loading-spinner__logo"
            src={advieskeuzeLogo as string}
            alt="Advieskeuze"
          />
        )}
        <div className="loading-spinner__orb" />
      </div>
      <span className="loading-spinner__text">
        {message || 'Resultaten worden geladen'}
      </span>
    </div>
  );
};

export default Loader;
